"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Teller_1 = require("../../../DriveScout/Billing/Teller");
var StudentFeesController = /** @class */ (function () {
    function StudentFeesController($stateParams, UsersModel, UserService) {
        var _this = this;
        this.inDollars = Teller_1.inDollars.bind(this);
        this.$stateParams = $stateParams;
        this.student = UserService.getCurrentUser();
        this.UsersModel = UsersModel;
        this.fees = [];
        this.UsersModel.getPickupLocations(this.student.id).then(function (response) {
            _this.addresses = response.pickuplocations.map(function (location) {
                return location.address;
            });
        });
        this.getFees();
    }
    StudentFeesController.prototype.getFees = function () {
        var _this = this;
        this.submitted = true;
        this.UsersModel.getStudentFees(this.student.id).then(function (response) {
            _this.fees = response.fees;
            _this.viewing = "fees";
            _this.submitted = false;
        });
    };
    return StudentFeesController;
}());
StudentFeesController.$inject = ["$stateParams", "UsersModel", "UserService"];
exports.default = StudentFeesController;
